import { MultimediaUploaderType } from '../../../../../../../../../../@types/multimedia-types'
import { useTranslation } from 'react-i18next'
import {
  IconS24DocumentText48,
  IconS24FloorPlan48,
  IconS24Picture48,
  IconS24QuestionMark48,
} from '@is24/cosma-ui-icons'
import React from 'react'
import { FlowInformation } from '../../../../../../../../../../@types/flow-types'

export type MultimediaButtonWrapperTypes = {
  allowedFileType: MultimediaUploaderType
  isFloorPlan: boolean
}

export interface MultimediaButtonTypes extends MultimediaButtonWrapperTypes {
  flowInformation: FlowInformation
  entryMode: string | undefined
}

export type MultimediaButtonContent = {
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  title: string
  fileTypes: string
}

export const getMultimediaButtonContent = (allowedFileType: MultimediaUploaderType): MultimediaButtonContent => {
  const { t } = useTranslation()
  const tPrefix = `wizard.screen.multimediaNew.buttons`
  switch (allowedFileType) {
    case MultimediaUploaderType.PICTURE:
      return {
        Icon: IconS24Picture48,
        title: t(`${tPrefix}.pictures.title`),
        fileTypes: t(`${tPrefix}.pictures.fileTypes`),
      }
    case MultimediaUploaderType.DOCUMENT: {
      return {
        Icon: IconS24DocumentText48,
        title: t(`${tPrefix}.documents.title`),
        fileTypes: t(`${tPrefix}.documents.fileTypes`),
      }
    }
    case MultimediaUploaderType.FLOOR_PLAN: {
      return {
        Icon: IconS24FloorPlan48,
        title: t(`${tPrefix}.floorPlans.title`),
        fileTypes: t(`${tPrefix}.floorPlans.fileTypes`),
      }
    }
    default: {
      return {
        Icon: IconS24QuestionMark48,
        title: '',
        fileTypes: '',
      }
    }
  }
}
